import React from "react";
import { TIMEOUT_ALERT_IN_SECUNDES } from "config";
import { staticData } from "managers/staticDataManager";

//place: ["tl", "tc", "tr", "bl", "bc", "br"]
//type: ["primary", "success", "danger", "warning", "info"]
const notification = (place, type, message, notificationAlertRef) => {
  var options = {};
  if (message
    && message.constructor === Array) {
      options = {
        place: place,
        message: (
          <div>
            {message.map((e, i) => {
                return <div>{e}</div>;
            })}
          </div>
        ),
        type: type,
        icon: "nc-icon nc-bell-55",
        autoDismiss: TIMEOUT_ALERT_IN_SECUNDES,
      };
  }
  else {
    options = {
      place: place,
      message: (
        <div>
          <div>{message}</div>
        </div>
      ),
      type: type,
      icon: "nc-icon nc-bell-55",
      autoDismiss: TIMEOUT_ALERT_IN_SECUNDES,
    };
  }

  if (notificationAlertRef && notificationAlertRef.current) {
    notificationAlertRef.current.notificationAlert(options);
  }
};

const error = (state, error, notificationReference, message) => {
  // console.log('notificationManager.error-message,error.response.data: ', message, error?.response?.data);
  if (!notificationReference) {
    return;
  }
  if (message) {
    return notification(
      "br",
      "danger",
      staticData.loadTerms(state, message),
      notificationReference
    );
  }
  if(error?.response?.data?.data
    && error.response.data.data.constructor === Array) {
      
      var messageList = [];
      if (error?.response?.data?.message) {
        // console.log('notificationManager.error-error.response.data: ', error.response.data);
        messageList.push(staticData.loadTerms(state, error.response.data.message));
      }

      error.response.data.data.forEach(e => {
        let msg = staticData.loadTerms(state, e.validationTerm);
        let resultMsg = replacePlaceholders(msg, e.validationData)
        messageList.push(resultMsg);
      });

      return notification(
        "br",
        "danger",
        messageList,
        notificationReference
      );
  }
  if (error.response && error.response.data && error.response.data.message) {
    return notification(
      "br",
      "danger",
      staticData.loadTerms(state, error.response.data.message),
      notificationReference
    );
  }
  //This stays as hardcoded message in any case
  return notification(
    "br",
    "danger",
    "Се случи комуникациска грешка. Обидете се повторно.",
    notificationReference
  );
};

function replacePlaceholders(template, dataArray) {
  // console.log('notificationManager.replacePlaceholders-template, dataArray: ', template, dataArray);
  if (!dataArray || !Array.isArray(dataArray) || dataArray.length === 0) return template;

  let result = template.replace(/{(\d+)}/g, (_, index) => {
      index = parseInt(index, 10);
      if (index < dataArray.length) {
        // console.log('notificationManager.replacePlaceholders-index, dataArray[index]: ', index, dataArray[index]);
        return `'${dataArray[index]}'`;
      } else {
        return `/`; // Keep the placeholder if index is out of bounds
      }
  });

  // console.log('notificationManager.replacePlaceholders-result: ', result);
  return result;
}


const success = (state, data, notificationReference) => {
  if (notificationReference)
    notification(
      "br",
      "success",
      staticData.loadTerms(state, data),
      notificationReference
    );
};

const info = (state, data, notificationReference) => {
  if (notificationReference)
    notification(
      "br",
      "info",
      staticData.loadTerms(state, data),
      notificationReference
    );
};

const warning = (state, data, notificationReference) => {
  if (notificationReference)
    notification(
      "br",
      "warning",
      staticData.loadTerms(state, data),
      notificationReference
    );
};

const notificationManager = { notification, success, info, warning, error };
export default notificationManager;
